import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {OrderHistory, OrderHistorySearch, ReduxPagination} from '@kion/data-models';

/*
export const loadAllSuccess = createActionWithCorrelation(
  "[Order] loadAll Success",
  props<{ orders: Order[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[Order] loadAll Error",
  props<{error: any}>()
);
export const loadAll = createActionWithCorrelation(
  "[Order] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);


export const loadByIdSuccess = createActionWithCorrelation(
  "[Order] load order by id success",
  props<{ order: Order }>()
);
export const loadByIdError = createActionWithCorrelation(
  "[Order] load order by id error",
  props<{ error: any }>()
);
export const loadById = createActionWithCorrelation(
  "[Order] load order by id",
  props<{ orderNumber: string }>(),
  loadByIdSuccess.type,
  loadByIdError.type
);
*/

export const loadOrderHistoryByIdSuccess = createActionWithCorrelation(
   "[OrderHistory] load order history by id success",
   props<{ orderHistory: OrderHistory }>()
);
export const loadOrderHistoryByIdError = createActionWithCorrelation(
   "[OrderHistory] load order history by id error",
   props<{ error: any }>()
);
export const loadOrderHistoryById = createActionWithCorrelation(
   "[OrderHistory] load order history by id",
   props<{ orderNumber: string }>(),
   loadOrderHistoryByIdSuccess.type,
   loadOrderHistoryByIdError.type
);

export const searchSuccess = createActionWithCorrelation(
   "[OrderHistory] search Success",
   props<{ searchResult: OrderHistorySearch }>()
);
export const searchError = createActionWithCorrelation(
   "[OrderHistory] search Error",
   props<{error: any}>()
);
export const search = createActionWithCorrelation(
   "[OrderHistory] search",
   props<{
      query?: string;
      useState: boolean;
      useDefaultPage: boolean;
      myOrders?: boolean;
      truckId?: string;
      sort?: string;
   }>(),
   searchSuccess.type,
   searchError.type
);

export const updatePerPageSuccess = createActionWithCorrelation(
    '[OrderHistory] update perPage success',
    props<{ pagination: ReduxPagination }>()
);
export const updatePerPageError = createActionWithCorrelation(
    '[OrderHistory] update perPage error',
    props<{ error: any }>()
);
export const updatePerPage = createActionWithCorrelation(
    '[OrderHistory] update perPage',
    props<{ perPage: number }>(),
    updatePerPageSuccess.type,
    updatePerPageError.type
);

export const updatePageSuccess = createActionWithCorrelation(
   '[OrderHistory] update Page success',
   props<{ pagination: ReduxPagination }>()
);
export const updatePageError = createActionWithCorrelation(
   '[OrderHistory] update Page error',
   props<{ error: any }>()
);
export const updatePage = createActionWithCorrelation(
   '[OrderHistory] update Page',
   props<{ page: number }>(),
   updatePageSuccess.type,
   updatePageError.type
);

export const updateQuerySuccess = createActionWithCorrelation(
    "[OrderHistory] update query success",
    props<{ query: string }>()
);
export const updateQueryError = createActionWithCorrelation(
    "[OrderHistory] update query error",
    props<{ error: any }>()
);
export const updateQuery = createActionWithCorrelation(
    "[OrderHistory] update query",
    props<{ query: string}>(),
    updateQuerySuccess.type,
    updateQueryError.type
);

export const updateSuccess = createActionWithCorrelation(
    "[OrderHistory] update success",
    props<{ orderHistory: OrderHistory }>()
);
export const updateError = createActionWithCorrelation(
    "[OrderHistory] update error",
    props<{ error: any }>()
);
export const update = createActionWithCorrelation(
    "[OrderHistory] update",
    props<{ orderId: string, note: string, poNumber: string}>(),
    updateSuccess.type,
    updateError.type
);